var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "connect_svg__Layer_1",
    viewBox: "0 0 28.81 38.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M53,28.62a6,6,0,1,0-7.09,5.9,5.07,5.07,0,0,1-1,3c-1.31,1.63-4,1.89-6.81,2.15a17.35,17.35,0,0,0-6,1.27,5,5,0,0,0-.73.43V29.7a6,6,0,1,0-2.4,0V44.35a6,6,0,1,0,2.79.09,3,3,0,0,1,1.42-1.35,15.55,15.55,0,0,1,5.17-1c3.2-.3,6.51-.61,8.46-3a7.38,7.38,0,0,0,1.48-4.55A6,6,0,0,0,53,28.62ZM26.6,23.82a3.6,3.6,0,1,1,3.6,3.6,3.6,3.6,0,0,1-3.6-3.6Zm7.2,26.41a3.6,3.6,0,1,1-3.61-3.6h0a3.6,3.6,0,0,1,3.57,3.6ZM47.89,32.11l-.88.11a3.6,3.6,0,1,1,.88-.11Z",
    transform: "translate(-24.2 -17.82)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnect);
export default __webpack_public_path__ + "static/media/connect.4f8e16676e3b3a336e112c0af9b4a361.svg";
export { ForwardRef as ReactComponent };